var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<iframe ng-src=\"{{modalCtrl.url}}\" class=\"document\"></iframe>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/tools/components/od-document-table/document-preview-modal.jade
 ** module id = 513
 ** module chunks = 0 1 3 4 5 6
 **/